import React from 'react'
import {
  FormControl,
  InputLabel,
  Select,
  OutlinedInput,
  MenuItem,
  Checkbox,
  ListItemText,
  SelectChangeEvent,
} from '@mui/material'
import { IntervalInputProps } from '../IntervalInputProps'

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
}

const labelInnerText = "Jours d'envoi:"
// const weekDays = ['lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi', 'dimanche']
const weekDays = {
  Lundi: 1,
  Mardi: 2,
  Mercredi: 3,
  Jeudi: 4,
  Vendredi: 5,
  Samedi: 6,
  Dimanche: 0,
}

// Individual conversions
const numberToDays = (number: number) => {
  return (Object.keys(weekDays) as Array<keyof typeof weekDays>).filter(
    (key) => weekDays[key as keyof typeof weekDays] === number,
  )[0]
}
const daysToNumber = (day: string) => {
  return weekDays[day as keyof typeof weekDays]
}
// Array conversions
const numberToDaysArray = (numbers: Array<number>) => {
  return numbers.map((number) => numberToDays(number))
}
const daysToNumberArray = (days: Array<string>) => {
  return days.map((day) => daysToNumber(day))
}

const sortArray = (sortedArray: Array<string>) => {
  return (Object.keys(weekDays) as Array<keyof typeof weekDays>).filter((value) =>
    sortedArray.includes(value),
  )
}

// /////////////////////////////////////////////////////////////////////////////////////////////////////////

const SpecificDaysSelector = ({ interval, setInterval }: IntervalInputProps) => {
  const isDaily = React.useMemo(
    () => interval.executionSchedule.frequency === 0,
    [interval.executionSchedule.frequency],
  )

  React.useEffect(() => {
    if (
      isDaily ||
      !interval.executionSchedule.specificDays ||
      interval.executionSchedule.specificDays?.length < 2
    ) {
      return
    }

    setInterval({
      ...interval,
      executionSchedule: {
        ...interval.executionSchedule,
        specificDays: [interval.executionSchedule.specificDays[0]],
      },
    })
  }, [isDaily])

  const specificDays = sortArray(numberToDaysArray(interval.executionSchedule.specificDays || []))

  const handleChange = (event: SelectChangeEvent<typeof specificDays>) => {
    const {
      target: { value },
    } = event
    const newSpecificDays = typeof value === 'string' ? value.split(',') : value

    setInterval({
      ...interval,
      executionSchedule: {
        ...interval.executionSchedule,
        specificDays: daysToNumberArray(sortArray(newSpecificDays as Array<string>)),
      },
    })
  }

  return (
    <FormControl className="w-full">
      <InputLabel id={labelInnerText}>{labelInnerText}</InputLabel>
      <Select
        labelId={labelInnerText}
        id="specific-days-selector"
        multiple={isDaily}
        value={specificDays}
        onChange={handleChange}
        input={<OutlinedInput label="Tag" />}
        renderValue={(selected) => selected.join(', ')}
        MenuProps={MenuProps}
      >
        {(Object.keys(weekDays) as Array<keyof typeof weekDays>).map((day) => (
          <MenuItem
            key={day}
            value={day}
          >
            <Checkbox checked={specificDays.includes(day)} />
            <ListItemText primary={day} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default SpecificDaysSelector
